import React from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardBody, CardFooter, CardHeader, Heading, HStack, Stack, Text } from "@chakra-ui/react"

const Blogs = () => {
    const navigate = useNavigate();

    const handleBlog = () => {
        navigate('/blogs'); 
    }
    const handleCategories = () => {
        navigate('/blog-categories'); 
    }
    const handleTags = () => {
        navigate('/tags'); 
    }

  return (
    <HStack   spacing={{ base: '16px', md: '24px', lg: '32px' }} // Adjust spacing between boxes for different screen sizes
    direction={{ base: 'column', md: 'row' }} // Stack boxes vertically on small screens, horizontally on larger screens
    align="center"
    justify="flex-start"
    w="100%" // Full width
    p={{ base: '4', md: '6' }}>
        <Box
        p={4}
        bg="blue.100"
        borderRadius="md"
        w={{ base: '100%', md: '45%', lg: '30%' }} // Adjust width based on screen size
        h={{ base: 'auto', md: '150px', lg: '200px'  }}
        boxShadow="md"
        _hover={{cursor:"pointer"}}
        onClick={handleBlog}
        display="flex"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
       <Heading> Blogs</Heading>
       </Box>
        <Box
        p={4}
        bg="blue.100"
        _hover={{cursor:"pointer"}}
        borderRadius="md"
        w={{ base: '100%', md: '45%', lg: '30%' }} // Adjust width based on screen size
        h={{ base: 'auto', md: '150px', lg: '200px'  }}
        boxShadow="md"
        display="flex"
        onClick={handleCategories}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
       <Heading> Blog Categories</Heading>
       </Box>
        <Box
        p={4}
        bg="blue.100"
        _hover={{cursor:"pointer"}}
        borderRadius="md"
        w={{ base: '100%', md: '45%', lg: '30%' }} // Adjust width based on screen size
        h={{ base: 'auto', md: '150px', lg: '200px'  }}
        boxShadow="md"
        display="flex"
        onClick={handleTags}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
       <Heading> Tags</Heading>
       </Box>
    </HStack>
  )
}
export default Blogs;